// extracted by mini-css-extract-plugin
export default {"container":"styles__container___SA97t","container-up":"styles__container-up___3JxK8"};